// removed by extract-text-webpack-plugin
module.exports = {"stat":"stat___1wWnH","stat-count-wrapper":"stat-count-wrapper___3rLgC center___2iqBf","stat-count":"stat-count___3jV0B center___2iqBf","stat-label":"stat-label___2lbme h4___kHWTn","red":"red___1IkZp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyIsPanels/CompanyIsFlag.css
// module id = 883
// module chunks = 0